import { Form, Formik } from "formik"
import { makeStyles } from "tss-react/mui"

import { useAppLocalization } from "../../../../../modules/localization/components/AppLocalizationProvider"
import { useDateTime } from "../../../../../modules/localization/useDateTime"
import { MeetingServiceOrder } from "../../../../../modules/merchant/accounting/accounting/accountingTypes"

import { SelectedMainUserState } from "../../createOrderTypes"
import { MeetingServiceFormContent } from "./MeetingServiceFormContent"
import { mergeValuesWithConfig } from "../form/mergeValuesWithConfig"
import { generateValidationSchema } from "../form/formLib"
import { useCreateOrderFormConfig } from "../../mainForm/CreateOrderFormContext"
import { OrderContextState } from "../../mainForm/helpers"
import {
    DynamicMainFormValues,
    MeetingServiceConfig,
    MainOrderFormikRef,
    MeetingServiceTabValues,
} from "../form/formTypes"

import { MEETING_SERVICE_FORM_ID } from "./helpers"

const useStyles = makeStyles()(() => ({
    form: {
        width: "100%",
    },
}))

type MeetingServiceFormProps = Readonly<{
    user: SelectedMainUserState
    handleClose: () => void
    handleOpenSelectPriceListsDialog: () => void
    meetingServiceConfiguration?: MeetingServiceConfig
    orderDetails?: MeetingServiceOrder
    mainValues: DynamicMainFormValues
    orderContext: OrderContextState
    handleSubmitMeetingService: (values: MeetingServiceTabValues) => void
    outerFormik: MainOrderFormikRef
}>

export function MeetingServiceForm({
    user,
    handleClose,
    handleOpenSelectPriceListsDialog,
    meetingServiceConfiguration,
    orderDetails,
    mainValues,
    orderContext,
    handleSubmitMeetingService,
    outerFormik,
}: MeetingServiceFormProps) {
    const dateTimeFactory = useDateTime()
    const { l10n } = useAppLocalization()
    const { classes } = useStyles()
    const { dialogType, flowConfig } = useCreateOrderFormConfig()

    const validationSchema = generateValidationSchema(dialogType, l10n, meetingServiceConfiguration)
    const initialValues = mergeValuesWithConfig({
        existing: mainValues,
        config: meetingServiceConfiguration,
        user,
        dateTimeFactory,
        dialogType,
        orderDetails,
        mode: orderContext.mode,
        flowConfig,
    }) as MeetingServiceTabValues

    return (
        <Formik
            initialValues={initialValues}
            validateOnBlur={false}
            validationSchema={validationSchema}
            onSubmit={handleSubmitMeetingService}
            enableReinitialize
        >
            <Form id={MEETING_SERVICE_FORM_ID} className={classes.form}>
                <MeetingServiceFormContent
                    user={user}
                    handleClose={handleClose}
                    handleOpenSelectPriceListsDialog={handleOpenSelectPriceListsDialog}
                    meetingServiceConfiguration={meetingServiceConfiguration}
                    outerFormik={outerFormik}
                    mode={orderContext.mode}
                    orderId={orderContext.orderId}
                />
            </Form>
        </Formik>
    )
}
